/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import styled, { css } from "styled-components"
import { theme } from "../../../constants/theme"

interface IArgosContextMenu {
    top?: number
    left?: number
    open?: boolean
  }

const ContextMenu = styled.div<IArgosContextMenu>((props) => {
    const {top, left} = props
    const isOpen = props.open ?? true
    if(!top || !left || !isOpen) {
        return null
    }
    return (
      {
        position: "absolute",
        width: "200px",
        color: "white",
        backgroundColor: theme.layout.sidebar.backgroundColor,
        borderRadius: "5px",
        boxSizing: "border-box",
        top: `${top}px`,
        left:`${left}px`,
        zIndex: 99999999,
        'ul': {
            boxSizing: "border-box",
            padding: '10px',
            margin: '0',
            listStyle: 'none',
        },
        'ul li': {
            padding: "18px 12px",
            ':hover': {
                cursor: 'pointer',
                backgroundColor: theme.layout.sidebar.footer.collapseButton.hoverColor
              }
          },
      }
    )
  })
  
  export default ContextMenu